/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app     = require('mag-app'),
    gettext = require('spa-gettext');


// main application events
app.once('load', function load () {
    app.pages = {
        main: require('./pages/main')
    };

    gettext.load({name: core.environment.language}, function () {
        parent.extendCorePrototype('accessControl', require('./modules/access.control'));

        app.route(app.pages.main);
    });
});
